/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorOptions } from './FactorOptions';
import {
    FactorOptionsFromJSON,
    FactorOptionsFromJSONTyped,
    FactorOptionsToJSON,
    FactorOptionsToJSONTyped,
} from './FactorOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface Factor
 */
export interface Factor {
    /**
     * 
     * @type {FactorMethod}
     * @memberof Factor
     */
    method?: FactorMethod;
    /**
     * 
     * @type {FactorOptions}
     * @memberof Factor
     */
    options?: FactorOptions;
}



/**
 * Check if a given object implements the Factor interface.
 */
export function instanceOfFactor(value: object): value is Factor {
    return true;
}

export function FactorFromJSON(json: any): Factor {
    return FactorFromJSONTyped(json, false);
}

export function FactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Factor {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'] == null ? undefined : FactorMethodFromJSON(json['method']),
        'options': json['options'] == null ? undefined : FactorOptionsFromJSON(json['options']),
    };
}

export function FactorToJSON(json: any): Factor {
    return FactorToJSONTyped(json, false);
}

export function FactorToJSONTyped(value?: Factor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'options': FactorOptionsToJSON(value['options']),
    };
}

